/* src/app/views/smart-filters/components/smart-filter-line-item/smart-filter-line-item.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.added-smart-filter {
  font-size: 0.75rem;
  column-gap: 0.75rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 0.063rem solid #f2f2f2;
}
.smart-filter-title {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.smart-filter-variant-count {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #9fa2ad;
}
.smart-filter-buttons {
  column-gap: 0.75rem;
}
/*# sourceMappingURL=smart-filter-line-item.component.css.map */
